export default class OrderError extends Error {
  errors: any
  refCode: any

  constructor(message) {
    super(message)
    this.name = 'OrderError'
  }
}
